var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import Toggle from '../../components/toggle';
import { RadioButton, RadioGroup } from '../../components/radio';
import Link from '../../components/link/Link';
import './CascadePolicy.scss';

var COMMUNITY_LINK = 'https://community.box.com/t5/Organizing-and-Tracking-Content/Metadata/ta-p/30765';

var CascadePolicy = function CascadePolicy(_ref) {
    var canEdit = _ref.canEdit,
        isCascadingEnabled = _ref.isCascadingEnabled,
        isCascadingOverwritten = _ref.isCascadingOverwritten,
        isCustomMetadata = _ref.isCustomMetadata,
        onCascadeToggle = _ref.onCascadeToggle,
        onCascadeModeChange = _ref.onCascadeModeChange,
        shouldShowCascadeOptions = _ref.shouldShowCascadeOptions;

    var readOnlyState = isCascadingEnabled ? React.createElement(
        'div',
        { className: 'metadata-cascade-notice' },
        React.createElement(FormattedMessage, messages.metadataCascadePolicyEnabledInfo)
    ) : null;

    return canEdit ? React.createElement(
        'div',
        { className: 'metadata-cascade-editor' },
        React.createElement(
            'div',
            { className: 'metadata-cascade-enable' },
            React.createElement(
                'div',
                null,
                React.createElement(FormattedMessage, _extends({
                    tagName: 'strong'
                }, messages.enableCascadePolicy)),
                !isCustomMetadata && React.createElement(Toggle, {
                    label: '',
                    className: 'metadata-cascade-toggle ' + (isCascadingEnabled ? 'cascade-on' : 'cascade-off'),
                    isOn: isCascadingEnabled,
                    onChange: function onChange(e) {
                        return onCascadeToggle(e.target.checked);
                    }
                })
            ),
            !isCustomMetadata ? React.createElement(
                'div',
                null,
                React.createElement(FormattedMessage, messages.applyCascadePolicyText),
                '\xA0',
                React.createElement(
                    Link,
                    {
                        className: 'cascade-policy-learnmore-link',
                        href: COMMUNITY_LINK,
                        target: '_blank'
                    },
                    React.createElement(FormattedMessage, messages.cascadePolicyLearnMore)
                )
            ) : React.createElement(
                'div',
                null,
                React.createElement(FormattedMessage, messages.cannotApplyCascadePolicyText)
            )
        ),
        shouldShowCascadeOptions && React.createElement(
            React.Fragment,
            null,
            React.createElement('hr', null),
            React.createElement(
                'div',
                { className: 'metadata-cascading-mode' },
                React.createElement(FormattedMessage, messages.cascadePolicyModeQuestion),
                React.createElement(
                    RadioGroup,
                    {
                        className: 'metadata-cascading-options',
                        value: isCascadingOverwritten ? 'overwrite' : 'skip',
                        onChange: function onChange(e) {
                            return onCascadeModeChange(e.target.value === 'overwrite');
                        }
                    },
                    React.createElement(RadioButton, {
                        label: React.createElement(FormattedMessage, messages.cascadePolicySkipMode),
                        value: 'skip'
                    }),
                    React.createElement(RadioButton, {
                        label: React.createElement(FormattedMessage, messages.cascadePolicyOverwriteMode),
                        value: 'overwrite'
                    })
                )
            )
        )
    ) : readOnlyState;
};

CascadePolicy.propTypes = {
    canEdit: PropTypes.bool.isRequired,
    isCascadingEnabled: PropTypes.bool.isRequired,
    isCascadingOverwritten: PropTypes.bool.isRequired,
    isCustomMetadata: PropTypes.bool.isRequired,
    onCascadeToggle: PropTypes.func.isRequired,
    onCascadeModeChange: PropTypes.func.isRequired,
    shouldShowCascadeOptions: PropTypes.bool.isRequired
};
export default CascadePolicy;
import PropTypes from 'prop-types';